module.exports = __webpack_public_path__ + "img/multiple-devices.952d89bf.png";